// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/document-type-pdf.svg';

export const DocumentTypePdf = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
